import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType, SubQuestionID } from '../types'
import {
  TopographyQuestionModelTypes,
  ITopographyQuestionModelState,
  ITopographyResponseValidation,
  TopographyFrameSubmitResponse,
  TopographySubmitResponse,
  IEntitySchema,
  IBatchSchema
} from './types'

const TopographyQuestionModel: IQuestionModelConstructor<TopographyQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<TopographyQuestionModelTypes, ITopographyQuestionModelState>({
    questionType: QuestionType.TOPOGRAPHY,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  model.navigationFrame = [1, model.schema.entities.length]
  return model
}

function submitResponse({ response, questionSchema }: ITopographyQuestionModelState) {
  const frames =
    0 == questionSchema.group_type
      ? questionSchema.entities.filter(entity => !entity.hidden)
      : questionSchema.entities[0]?.matrix_batches.filter(b => !b.hidden)
  if (!frames?.length) return []

  const submit = response
    .map(
      (el, frame) =>
        el.data?.reduce((acc: TopographyFrameSubmitResponse, item) => {
          if (item.hidden || null == item.value) return acc
          const batch =
            0 == questionSchema.group_type
              ? questionSchema.entities
                  .filter(b => !b.hidden)
                  [frame]?.matrix_batches.filter(b => !b.hidden)
                  .find((batch: IBatchSchema) => item.id == batch.id)
              : questionSchema.entities
                  .find((entity: IEntitySchema) => item.id == entity.id)
                  ?.matrix_batches?.filter((b: IBatchSchema) => !b.hidden)[frame]

          // item.value because Sliders component min value is 1, not 0
          const value = 2 == questionSchema.scale_type ? item.value - 1 : item.value
          acc.push({ id: batch.answers[value]?.id })
          return acc
        }, [])
    )
    // exclude fake hidden and hidden frames from response
    .filter((_r, index) => !frames[index].fakeHidden)

  return [].concat(...submit) as TopographySubmitResponse
}

function initState(state: ITopographyQuestionModelState): ITopographyQuestionModelState {
  state.response = []
  return state
}

function validateResponse({
  response,
  questionSchema,
  frame
}: ITopographyQuestionModelState): ITopographyResponseValidation {
  if (
    !questionSchema.entities.filter(entity => !entity.hidden).length ||
    !questionSchema.entities[0].matrix_batches?.filter(batch => !batch.hidden).length
  ) {
    return { valid: true }
  }

  const currentResponse = response[frame as number]
  if (!currentResponse)
    return {
      valid: false,
      invalidBatches: []
    }

  const invalidBatches: SubQuestionID[] = []
  currentResponse.data.forEach(item => {
    if (null === item.value && !item.hidden) invalidBatches.push(item.id)
  })

  return {
    valid: !invalidBatches.length,
    invalidBatches: invalidBatches
  }
}

export default TopographyQuestionModel
